import {Controller} from "stimulus"


export default class extends Controller {

    connect() {

        this.eventData = this.element.getAttribute('data-data');
        this.tiktokEventId = this.element.getAttribute('data-tiktok-event-id');
        this.eventData = JSON.parse(this.eventData);

        this.facebookPurchase();
    }

    facebookPurchase() {
        let fbData = this.prepareFacebookPurchaseData();

        fbq('track', 'Purchase',
            {
                value: fbData.total,
                currency: 'EUR',
                contents: fbData.products,
                content_type: 'product',
            }
        );

        if (this.tiktokEventId) {
            let tikTokData = this.prepareTiktokPurchaseData();
            ttq.track('Purchase', tikTokData, {
                "event_id": this.tiktokEventId
            });
        }

    }


    prepareFacebookPurchaseData() {

        let data = {};
        data.products = [];
        data.total = this.eventData.totalInEur

        this.eventData.products.forEach(row => {
            let product = {};
            product.id = row.id;
            product.quantity = row.quantity;
            product.item_price = row.price;
            data.products.push(product);
        })

        return data;
    }
    prepareTiktokPurchaseData() {

        let data = {};
        data.contents = [];
        data.value = this.eventData.totalInEur;
        data.currency = 'EUR';
        data.event_id = this.tiktokEventId;

        this.eventData.products.forEach(row => {
            let product = {};
            product.content_id = row.id;
            product.content_type = "product";
            product.content_name = row.name;
            product.content_category = row.category;
            product.content_category = row.categoryName;
            product.num_items = row.quantity;
            product.price = row.price;
            data.contents.push(product);
        })


        return data;
    }
}